export default __webpack_public_path__ + "static/media/06 - Default.aspx.cs (1).fd16e1e0.png";